/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PsLanguageSelect.vue?vue&type=template&id=9e291786&"
import script from "./PsLanguageSelect.vue?vue&type=script&lang=ts&"
export * from "./PsLanguageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports